import { useTranslation } from 'react-i18next';
import { YoutubeCompareTagRanking } from '@anytag/graphql';
import { ColumnDef } from '@tanstack/react-table';
import {
  AnalyticsComparePostsAccount,
  AnalyticsCompareTagsRankingTable,
  AnalyticsCompareTagsRankingSlider
} from '../../shared';
import { AnalyticsYoutubeComparableAccountType } from '../types';

interface TemplateProps {
  data: YoutubeCompareTagRanking;
  comparableAccounts: AnalyticsYoutubeComparableAccountType[];
}

export const Template = ({ data, comparableAccounts }: TemplateProps) => {
  const { t } = useTranslation();

  const composeData = [
    data.mainAccount,
    ...(data.compareAccounts.filter((account) => account.accountId !== data.mainAccount.accountId) || [])
  ];
  const tableData = comparableAccounts.map((account) => ({
    account,
    tagsRanking: composeData.find((item) => item.accountId === account.id)?.tagsRanking
  }));
  const columns: ColumnDef<(typeof tableData)[number]>[] = [
    {
      size: 160,
      accessorKey: 'account',
      header: t<string>('HeaderColumn.Account'),
      cell: ({ row }) => (
        <AnalyticsComparePostsAccount
          account={{
            name: row.original.account.username,
            avatar: row.original.account.avatarUrl
          }}
        />
      )
    },
    {
      size: 2000, // take all the space
      accessorKey: 'tagsRanking',
      header: '',
      cell: ({ row }) => <AnalyticsCompareTagsRankingSlider data={row.original.tagsRanking} />
    }
  ];

  return <AnalyticsCompareTagsRankingTable data={tableData} columns={columns} />;
};
